<template>
  <div v-if="tags && tags.length">
    <span
      class="tag"
      v-for="(tagItem, tagKey) in tags"
      v-bind:key="tagKey"
    >
      <a v-if="tagItem && tagItem.Item" :href="'/dashboard/tag-details/' + tagItem.Item.Id"><feather-icon icon="TagIcon" class="tag-icon"></feather-icon
      >{{ tagItem.Item.Title }}</a>
    </span>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  methods: {},
  mounted() {},
  watch: {},
  props: ["tags"],
  components: {},
};
</script>
<style scoped>
* >>> .tag {
  padding: 3px;
  color: #7402ff;
  font-size: x-small;
  display: inline-block;
}

* >>> .tag-icon {
  width: 1em;
  height: 1em;
  text-align: center;
  vertical-align: middle;
  margin-right: 3px;
}
</style>
